<template>
  <div class="main-wrapper error-page">
    <div class="content ellipses">
      <div class="container">
        <header class="text-center mt-0">
          <router-link to="/trang-chu">
            <img src="@/assets/img/logo_red.png" class="img-fluid" alt="Logo" />
          </router-link>
        </header>
        <div class="errors-img">
          <img src="@/assets/img/404.png" class="img-fluid" alt="Venue" />
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-6 col-lg-5 mx-auto text-center">
            <h3>
              Trang web này hiện đang được bảo trì.
            </h3>
            <p>Chúng tôi xin lỗi vì sự bất tiện này.
              Chúng tôi sắp hoàn thành!</p>
            <router-link
              to="/trang-chu"
              class="btn btn-primary d-inline-flex align-items-center"
              >Về trang chủ<i class="feather-arrow-right-circle ms-2"></i
            ></router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
